var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.computedData.length > 0
    ? _c("Plotly", {
        attrs: {
          data: _vm.computedData,
          layout: _vm.computedLayout,
          "to-image-button-options":
            _vm.defaultConfiguration.toImageButtonOptions,
          displaylogo: false,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }